<template>
        <fg-input class="btn-one-size btn-one-size-custom">
            <el-select size="large"
                       class="select-primary"
                       fullWidth
                       @change="redirectTeam"
                       :value="$route.params.tid">
                <el-option v-for="option in teams"
                           :value="option._id"
                           :label="$t(option.title)"
                           :key="option._id">
                </el-option>
            </el-select>
        </fg-input>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import { Select, Option } from 'element-ui'

    export default {
        name: "TeamDropDownList",
        components: {
            [Select.name]: Select,
            [Option.name]: Option
        },
        data () {
            return {
                sf: 'name',
                so: 'asc',
                columns: [
                    { name: 'title', text: 'Name', sortable: false, align: 'left', minWidth: 150 }
                ]
            }
        },
        async mounted () {
            this.init()
        },
        computed: {
            ...mapGetters({ getTeams: 'user/teams/teamsByQuestionnaire/getTeams' }),
            teams: function () {
                return this.getTeams(this.$route.params.qid)
            }
        },
        methods: {
            ...mapActions('user/teams/teamsByQuestionnaire', ['getList']),
            async init () {
                await this.getList({ questionnaireId: this.$route.params.qid, sf: 'title', so: 'asc' })
            },
            redirectTeam (value) {
                return this.$router.push({ name: 'TeamView', params: { qid: this.$route.params.qid, tid: value } })
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 590px) {
      .btn-one-size-custom {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
        margin-left: 0px;
      }
    }
</style>